export enum endPoints {
  LOGIN = '/login/:merchant_id',
  MY_SHOPS = '/my-shops',
  CREATE = '/create',
  DEFAULT_PAGE = '/',
  WINDOW = '/window',
  ORDERS = '/orders',
  MENU = '/menu'
}
